import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useScopedAtomValue } from '@lemon8/webapp-shared/component';
import { $NestedSwiperSlideInfo } from '~/components/article-gallery/atoms';
import cls from 'classnames';

import './style.scss';

export const GalleryIndex: FC = () => {
  const nestedSwiperSlideInfo = useScopedAtomValue($NestedSwiperSlideInfo);

  const [galleryIndexShow, setGalleryIndexShow] = useState(true);
  const hiddenTimeout = useRef<number>();

  useEffect(() => {
    setGalleryIndexShow(true);
    window.clearTimeout(hiddenTimeout.current);
    hiddenTimeout.current = window.setTimeout(() => {
      setGalleryIndexShow(false);
    }, 3000);
  }, [nestedSwiperSlideInfo.current]);

  return (
    <div className={cls('article-gallery-index', { hidden: !galleryIndexShow })}>
      {`${nestedSwiperSlideInfo.current + 1}/${nestedSwiperSlideInfo.length}`}
    </div>
  );
};
